import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/credit_debit_card.svg';

const CreditDebitCard = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};

export default CreditDebitCard;
